import type { KioskSessionView } from '@print-saas/shared';
import { PayIcon } from '../components/icons';
import { MessageScreen } from '../components/MessageScreen';
import { useNow } from '../hooks/useNow';
import { formatPrice, plural } from '../lib/format';
import { Countdown } from './ActiveScreen';

export function AwaitingPaymentScreen({ session }: { session: KioskSessionView }) {
  const now = useNow();
  return (
    <MessageScreen
      tone="accent"
      icon={<PayIcon />}
      title="Waiting for payment"
      subtitle="Complete the payment on your phone. Printing starts automatically."
    >
      <div className="mt-[2vmin] flex flex-col items-center rounded-[3vmin] bg-accent/10 px-[7vmin] py-[3vmin] ring-2 ring-accent/50">
        <div className="text-[2.4vmin] font-semibold tracking-widest text-muted uppercase">Amount</div>
        <div key={session.totalAmount} className="animate-pop text-[11vmin] leading-none font-black text-accent tabular-nums">
          {formatPrice(session.totalAmount)}
        </div>
        <div className="mt-[1.5vmin] text-[2.4vmin] text-muted">
          {plural(session.fileCount, 'file')} · {plural(session.totalSheets, 'sheet')}
        </div>
      </div>
      <Countdown label="Time left to pay" ms={Date.parse(session.expiresAt) - now} />
    </MessageScreen>
  );
}
